import React from 'react'
import { StorefrontEventWithProducts } from '@/modules/event/getEvent'

export type ChronoPageProps = {
  header?: string | React.ReactNode,
  event?: StorefrontEventWithProducts,
  label: string | React.ReactNode
  controls?: React.ReactNode
  children?: React.ReactNode
  'data-cy'?: string
}

export type AutoFillField =
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'streetAddress1'
  | 'streetAddress2'
  | 'city'
  | 'state'
  | 'postalCode'
  | 'country'
  | 'ccName'
  | 'ccNumber'
  | 'ccExp'
  | 'ccCsc'
  | 'birthDay'
  | 'phone'
  | 'phoneNational'
  | 'oneTimeCode'

export const AutoFillFields: { [key in AutoFillField]: string } = {
  firstName: 'given-name',
  lastName: 'family-name',
  email: 'email',
  streetAddress1: 'address-line1',
  streetAddress2: 'address-line2',
  state: 'address-level1',
  city: 'address-level2',
  country: 'country',
  postalCode: 'postal-code',
  ccName: 'cc-name',
  ccNumber: 'cc-number',
  ccExp: 'cc-exp',
  ccCsc: 'cc-csc',
  birthDay: 'bday',
  phone: 'tel',
  phoneNational: 'tel-national',
  oneTimeCode: 'one-time-code',
}